var _radialGradient, _circle, _radialGradient2, _circle2, _radialGradient3, _circle3, _circle4, _circle5, _circle6, _circle7, _radialGradient4, _path, _radialGradient5, _path2, _radialGradient6, _circle8, _radialGradient7, _path3, _radialGradient8, _circle9, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlushedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNa",
    cx: -928,
    cy: 24,
    r: 18,
    fx: -928.095,
    fy: 16.289,
    gradientTransform: "translate(952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#f6bd1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f0af13"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#MUBj6njjqt2HL0ZtueeuNa)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNb",
    cx: 34.5,
    cy: 30.5,
    r: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f40",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f40",
    stopOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 30.5,
    r: 5.5,
    fill: "url(#MUBj6njjqt2HL0ZtueeuNb)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNc",
    cx: 13.5,
    cy: 30.5,
    r: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f40",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f40",
    stopOpacity: 0
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 30.5,
    r: 5.5,
    fill: "url(#MUBj6njjqt2HL0ZtueeuNc)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 5,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 2,
    fill: "#212121"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24,
    r: 5,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24,
    r: 2,
    fill: "#212121"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNd",
    cx: 153.354,
    cy: 33.698,
    r: 5.725,
    gradientTransform: "matrix(.7594 0 0 .5686 -92.374 14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MUBj6njjqt2HL0ZtueeuNd)",
    d: "M24.003,35C20.424,35,20,35,20,35s1.006,2,4.003,2S28,35,28,35S27.582,35,24.003,35z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNe",
    cx: 24.056,
    cy: 34.423,
    r: 4.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MUBj6njjqt2HL0ZtueeuNe)",
    d: "M28.327,35c0,0-0.398,0-4.327,0s-4.327,0-4.327,0v-2.057h8.654V35z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNf",
    cx: -787.493,
    cy: -382.037,
    r: 0.865,
    gradientTransform: "rotate(180 -384 -174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 33.5,
    r: 0.5,
    fill: "url(#MUBj6njjqt2HL0ZtueeuNf)"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNg",
    cx: -791.937,
    cy: -382.075,
    r: 3.804,
    gradientTransform: "rotate(180 -384 -174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MUBj6njjqt2HL0ZtueeuNg)",
    d: "M19.5,34H24h4.5l0.167-0.973c0,0-2.232-1.027-4.667-1.027s-4.667,1.027-4.667,1.027L19.5,34z"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "MUBj6njjqt2HL0ZtueeuNh",
    cx: 37.507,
    cy: -382.037,
    r: 0.865,
    gradientTransform: "matrix(1 0 0 -1 -9 -348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 33.5,
    r: 0.5,
    fill: "url(#MUBj6njjqt2HL0ZtueeuNh)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M35.071,15.757c-0.31-0.36-0.887-0.747-1.435-0.987c-0.564-0.258-1.172-0.438-1.796-0.557 c-0.619-0.132-1.263-0.184-1.901-0.225c-0.645-0.022-1.292-0.007-1.939,0.028l-0.017,0.001c-0.562,0.031-1.042-0.4-1.072-0.962 c-0.031-0.562,0.4-1.042,0.962-1.072c0.041-0.002,0.088-0.001,0.128,0.001c0.713,0.051,1.425,0.126,2.134,0.241 c0.709,0.135,1.414,0.285,2.104,0.526c0.69,0.226,1.367,0.521,1.998,0.914c0.636,0.411,1.208,0.828,1.692,1.578 c0.148,0.23,0.082,0.536-0.147,0.684c-0.21,0.136-0.485,0.092-0.644-0.093L35.071,15.757z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M11.146,15.146c0.631-0.625,1.28-1.029,1.99-1.419c0.704-0.376,1.444-0.673,2.198-0.919 c0.756-0.247,1.53-0.421,2.309-0.56c0.781-0.135,1.567-0.212,2.356-0.265c0.561-0.037,1.046,0.387,1.084,0.948 c0.037,0.561-0.387,1.046-0.948,1.084c-0.038,0.003-0.077,0.003-0.114,0.001L20,14.016c-0.717-0.033-1.436-0.047-2.151-0.005 c-0.714,0.045-1.429,0.121-2.129,0.264c-0.699,0.143-1.39,0.332-2.052,0.593c-0.647,0.256-1.324,0.602-1.815,0.986l-0.05,0.039 c-0.217,0.169-0.53,0.131-0.699-0.086C10.948,15.606,10.969,15.322,11.146,15.146z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlushedFace);
export default __webpack_public_path__ + "static/media/flushed-face.dca3079125ee7c77e7c8110864c5e54a.svg";
export { ForwardRef as ReactComponent };